// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6a97343","897":"b8708dcf"}[chunkId] + ".chunk.js";
};